import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import cx from 'classnames2';
import React from 'react';
import { useListTableVariantContext } from '../ListTable';
import styles from './ListTable.Row.scss';
export var ListTableRow = function ListTableRow(_ref) {
  var _cx;

  var ariaLabel = _ref.ariaLabel,
      dataTest = _ref.dataTest,
      children = _ref.children,
      onClick = _ref.onClick,
      selected = _ref.selected,
      href = _ref.href;
  var Element = href ? 'a' : 'div';
  var listTableVariant = useListTableVariantContext();
  return React.createElement(Element, Object.assign({}, href ? {
    href: href
  } : {
    role: 'button'
  }, {
    tabIndex: 0,
    className: cx(styles.row, (_cx = {}, _defineProperty(_cx, styles.stateSelected, selected), _defineProperty(_cx, styles.variantCondensed, listTableVariant === 'condensed'), _cx)),
    onClick: onClick,
    "data-test": dataTest,
    "aria-label": ariaLabel
  }), children);
};